const channels = [
  { icon: 'ri-whatsapp-line', gradient: 'from-green-500 to-emerald-500', title: 'WhatsApp', desc: 'Instant support via WhatsApp', speed: '⚡ < 5 min', hours: '🕒 10am–midnight', contact: '+1 (205) 709 2376' },
  { icon: 'ri-phone-line', gradient: 'from-blue-500 to-cyan-500', title: 'Phone', desc: 'Direct phone assistance', speed: '⚡ Immediate', hours: '🕒 10am–midnight', contact: '+1 (205) 709 2376' },
  { icon: 'ri-mail-line', gradient: 'from-purple-500 to-pink-500', title: 'Email', desc: 'Technical support by email', speed: '⚡ < 2h', hours: '🕒 10am–midnight', contact: 'support@4k-dream.com' },
  { icon: 'ri-home-line', gradient: 'from-orange-500 to-[#862ce0]', title: 'Home Visit', desc: 'Technical intervention at your home', speed: '⚡ 24-48h', hours: '🕒 Mon-Sat', contact: 'By appointment' },
];

const Support = () => (
  <section id="support" className="py-12 md:py-20 bg-gradient-to-br from-gray-900 via-green-900/20 to-blue-900/20">
    <div className="max-w-7xl mx-auto px-4">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-green-400 via-blue-500 to-purple-500 bg-clip-text text-transparent">
          Customer Support 7 Days/7
        </h2>
        <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-8">
          A dedicated team available every day from 10am to midnight to accompany you at every step
        </p>
        <div className="relative max-w-4xl mx-auto mb-12">
          <img alt="Support" className="w-full h-auto rounded-2xl" loading="lazy" src="https://4kkdream.com/iptv-support-D1W-sOPd.jpg" />
          <div className="absolute inset-0 bg-gradient-to-r from-green-600/20 to-blue-600/20 rounded-2xl"></div>
          <div className="absolute top-4 left-4">
            <span className="bg-green-500 text-white font-bold px-4 py-2 rounded-full text-xs animate-pulse">🟢 Support Active 7 days/7</span>
          </div>
        </div>
      </div>
      <div className="mb-16">
        <h3 className="text-3xl font-bold text-center mb-12 text-white">Contact Us Through Your Preferred Channel</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {channels.map((c) => (
            <div key={c.title} className="bg-gray-800/50 border border-gray-700 hover:border-green-500/50 transition-all duration-300 rounded-lg group">
              <div className="p-6 text-center">
                <div className={`w-16 h-16 bg-gradient-to-r ${c.gradient} rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${c.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="font-semibold text-white text-lg mb-2">{c.title}</h3>
                <p className="text-gray-400 text-sm mb-3">{c.desc}</p>
                <div className="flex flex-col gap-1 mb-3">
                  <span className="inline-block bg-green-500/20 text-green-400 border border-green-500/30 text-xs px-2.5 py-0.5 rounded-full font-semibold">{c.speed}</span>
                  <span className="inline-block border border-gray-600 text-gray-300 text-xs px-2.5 py-0.5 rounded-full font-semibold">{c.hours}</span>
                </div>
                <div className="text-white font-mono text-sm p-2 bg-gray-700/50 rounded break-all">{c.contact}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="text-center">
        <a href="https://wa.me/12057092376" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 via-blue-500 to-purple-500 hover:opacity-90 text-white px-8 py-4 text-lg font-semibold rounded-md mr-4 cursor-pointer whitespace-nowrap">
          <i className="ri-whatsapp-line"></i> Contact Support
        </a>
        <a href="tel:+12057092376" className="inline-flex items-center gap-2 border border-green-500/50 text-green-400 hover:bg-green-500/20 px-8 py-4 text-lg rounded-md cursor-pointer whitespace-nowrap">
          +1 (205) 709 2376
        </a>
        <p className="text-gray-400 text-sm mt-4">💬 WhatsApp • 📞 Phone • 📧 Email • 🏠 Home</p>
      </div>
    </div>
  </section>
);

export default Support;
